<h2>My Heroes</h2>
<ul class="heroes">
  <li *ngFor="let hero of (heroes | async)">
    <a routerLink="/detail/{{hero.id}}">
      <span class="badge">{{hero.id}}</span> {{hero.name}}
    </a>
  </li>
</ul>
<!-- <app-hero-detail [hero]="selectedHero"></app-hero-detail> -->
